@if (thankyoupop) {
  <div class="content-wrapper">
    <div class="header_area">
      <div class="header_content">
        <div class="site_logo">
          <a routerLink="/"><img class="logo_img" src="assets/images/familycentral-logo.svg"
          alt="Family Central"></a>
        </div>
      </div>
    </div>
    <div class="thankyou-content">
      <div class="text-area">
        <h1 class="heading1">
          Thank You!
        </h1>
        <p>You will now receive communication from Family Central.</p>
        <p>We will redirect to the Family Central Homepage within <span>{{remainingTime}}</span> seconds...</p>
      </div>
    </div>
  </div>
}